import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { AccordionItem } from "../../components/AccordionItem";
import "./Faq.css";
class Faq extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            sections: [
                {
                    id: "getting_started",
                    questions: ["what_do_i_say", "what_kinds_of_things"],
                },
                {
                    id: "creating_and_managing",
                    questions: [
                        "i_added_stories",
                        "how_do_i_know",
                        "i_have_other_audio",
                        "how_do_i_download",
                        "how_do_i_delete",
                    ],
                },
                {
                    id: "accessing_my_storytime",
                    questions: [
                        "who_can_access",
                        "family_access",
                        "child_invite",
                        "child_voice",
                    ],
                },
                {
                    id: "about_my_storytime",
                    questions: ["who_built", "technical_issues"],
                },
            ],
            openHash: "",
        };
    }
    componentWillMount() {
        const { location } = this.props;
        const hash = location.hash.replace(/^#/, "");
        // if (hash && this.state.questions.includes(hash)) {
        if (hash) {
            this.setState({ openHash: hash });
        }
    }
    componentDidMount() {
        this.timeout = setTimeout(() => {
            const openQ = document.getElementById(this.state.openHash);
            if (openQ) {
                const scrollPos = openQ.getBoundingClientRect().top;
                window.scrollTo(0, scrollPos);
            }
        }, 300);
    }
    componentWillUnmount() {
        if (this.timeout !== undefined) {
            clearTimeout(this.timeout);
        }
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: "faq-container" },
            React.createElement("h1", { className: "faq-headline" }, t("faq.faqs")),
            React.createElement("div", { className: "content-container content-container--grid" },
                React.createElement("div", { className: "content-container--col" },
                    React.createElement("h2", { className: "faq-subhead" }, t("faq.faq_subhead")),
                    React.createElement("p", { className: "faq-intro" }, t("faq.faq_intro"))),
                React.createElement("div", { className: "content-container--col" },
                    React.createElement("ul", { className: "anchor-links" }, this.state.sections.map(faqSection => {
                        return (React.createElement("li", { key: `${faqSection.id}-link` },
                            React.createElement("a", { href: "#" + faqSection.id }, t(`faq.sections.${faqSection.id}.title`))));
                    })))),
            React.createElement("div", { className: "content-container" }, this.state.sections.map(faqSection => {
                return (React.createElement("div", { id: faqSection.id, key: `${faqSection.id}-title` },
                    React.createElement("h3", { className: "accordion-header" }, t(`faq.sections.${faqSection.id}.title`)),
                    React.createElement("ul", { className: "accordion-container" }, faqSection.questions.map(faqItem => {
                        const answer = t(`faq.sections.${faqSection.id}.questions.${faqItem}.answer`);
                        const question = t(`faq.sections.${faqSection.id}.questions.${faqItem}.question`);
                        return (React.createElement(AccordionItem, { key: faqItem, id: faqItem, title: question, content: answer, open: this.state.openHash === faqItem }));
                    }))));
            }))));
    }
}
export default withTranslation()(Faq);
//# sourceMappingURL=Faq.js.map